import _ from 'lodash';
import { IntentLabelConfig } from '../configs';
import {
  createCaseIndexMapping, createLabelMapping, getLastLabelByCaseIndex, updateCases, updatePipeConfigs
} from './utils/caseLabelUtils';

export const updateCaseIndexes = (cases, pipeConfigs, deletedCaseIdx) => {
  const caseIndexMapping = createCaseIndexMapping(cases, deletedCaseIdx);
  const labelMappedConfig = createLabelMapping(cases, false);
  const newCases = cases.filter((_, index) => index !== deletedCaseIdx);

  IntentLabelConfig.reset();
  _.forEach(getLastLabelByCaseIndex(caseIndexMapping, labelMappedConfig), (label, caseIndex) => {
    IntentLabelConfig.setConfigNameAndValue(caseIndex, label);
  });

  return {
    updatedCases: updateCases(newCases, labelMappedConfig, caseIndexMapping),
    updatedPipeConfigs: updatePipeConfigs(pipeConfigs, labelMappedConfig, caseIndexMapping),
  };
};
